import React, { FC } from 'react'
import styles from 'styles/components/card.module.scss'

type Props = {
  isTop?: boolean
  headline: string
}

const CardGreyHeadline: FC<Props> = React.memo((props) => {
  const { headline, isTop } = props

  const className = isTop ? styles.headline_grey_top : styles.headline_grey

  return <h4 className={className}>{headline}</h4>
})

export default CardGreyHeadline
